import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-59ff0761"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "svg-group"
};
const _hoisted_2 = {
  key: 1,
  class: "svg-group"
};
import { ref } from 'vue';
function setup(__props, {
  emit
}) {
  const props = __props;
  const searchValue = ref(props.searchData.searchTitle);
  const searchQuery = () => {
    emit('searchQuery', searchValue.value);
  };
  const closeSearch = () => {
    searchValue.value = '';
    emit('closeSearch', searchValue.value);
  };
  return (_ctx, _cache) => {
    const _component_SvgIcon = _resolveComponent("SvgIcon");
    const _component_el_divider = _resolveComponent("el-divider");
    const _component_el_input = _resolveComponent("el-input");
    return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_input, {
      modelValue: searchValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchValue.value = $event),
      class: "search",
      maxlength: __props.searchData.maxlength,
      placeholder: __props.searchData.placeholder,
      onKeyup: _withKeys(searchQuery, ["enter"])
    }, {
      suffix: _withCtx(() => [searchValue.value.length <= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_SvgIcon, {
        icon: "search",
        size: 18,
        onClick: searchQuery
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: "svg-close",
        onClick: closeSearch
      }, [_createVNode(_component_SvgIcon, {
        icon: "close",
        size: 10
      })]), _createVNode(_component_el_divider, {
        direction: "vertical"
      }), _createElementVNode("div", {
        class: "svg-search",
        onClick: searchQuery
      }, [_createVNode(_component_SvgIcon, {
        icon: "search",
        color: "#fff",
        size: 16
      })])]))]),
      _: 1
    }, 8, ["modelValue", "maxlength", "placeholder", "onKeyup"])]);
  };
}
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'CommonSearch'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    searchData: {
      type: Object,
      required: true
    }
  },
  emits: ['searchQuery', 'closeSearch'],
  setup
});